import { NicheFields, NicheFieldsNames } from "@/components/popups/NicheForm/NicheForm";

export const INITIAL_STEP = "INITIAL_STEP";
export const CREATE_STEP = "CREATE_STEP";
export const SUCCESS_STEP = "SUCCESS_STEP";
export const DUPLICATE_CODE = "DuplicateNiche";

export const CREATE_NICHE_FIELDS: { [key in NicheFieldsNames]: NicheFields } = {
  [NicheFieldsNames.name]: {
    id: "name",
    label: "Name",
    placeholder: "Give your Niche a name...",
    validation: {
      required: "Give your niche a unique name",
    },
    type: "text",
    defaultValue: ""
  },
  [NicheFieldsNames.description]: {
    id: "description",
    label: "Description",
    placeholder: "What can viewers and contributors to your Niche expect to find? Niches with clear and detailed descriptions perform much better than those without...",
    validation: {
      required: "Let other users know what this niche is about",
      minLength: { value: 30, message: "Longer descriptions help other users (min 30 characters)" }
    },
    rows: 4,
    defaultValue: ""
  },
  [NicheFieldsNames.rules]: {
    id: "rules",
    label: "Posting Guidelines",
    placeholder: "All niches must adhere to our Community Guidelines but Niche owners are also free to add their own rules and guidelines...",
    validation: {
      required: "Let other users know what is expected of them",
      minLength: { value: 30, message: "Set clear expectations for others (min 30 characters)" }
    },
    rows: 5,
    defaultValue: ""
  }
};
